<template>
  <div class="media-list">
    <div class="main-box" v-if="step == 1">
      <el-form :inline="true" label-width="125px" :model="formCustom">
        <el-form-item label="专辑名称: " label-width="120px">
          <el-input
            style="width: 300px"
            v-model="formCustom.albumName"
            :disabled="doWhatTemp === 'view'"
          />
        </el-form-item>
        <el-form-item label="出版社: " label-width="120px">
          <el-input
            style="width: 300px"
            v-model="formCustom.albumPublisher"
            :disabled="doWhatTemp === 'view'"
          />
        </el-form-item>
        <br />
        <el-form-item label="专辑封面: " label-width="120px">
          <el-row type="flex" class="row-bg">
            <el-col :span="12" v-if="formCustom.img_large != ''">
              <img :src="formCustom.img_large" width="80px" height="80px" />
            </el-col>
            <el-col :span="12">
              <Upload
                action="/aries-api/resource/upload"
                type="drag"
                accept="image/jpeg, image/gif, image/png"
                :before-upload="onBeforeUpload"
                :on-success="onSuccessUpload"
                :data="uploadData"
                :show-upload-list="false"
                :disabled="doWhatTemp === 'view'"
                style="width: 80px; height: 80px"
              >
                <div style="padding: 20px 0">
                  <Icon
                    type="ios-cloud-upload"
                    size="32"
                    color="#3399ff"
                  ></Icon>
                </div>
              </Upload>
            </el-col>
          </el-row>
        </el-form-item>
        <br />
        <el-form-item label="关联绘本: " label-width="120px">
          <AddPictureBook
            :doWhatTemp="doWhatTemp"
            :currCpId="currCpId"
            :isSystem="isSystem"
            @resourseSel="handleResAdd"
          />
        </el-form-item>
        <br />
        <el-form-item label="词汇量: " label-width="120px">
          <el-input
            style="width: 300px"
            v-model.number="formCustom.readCount"
            :disabled="doWhatTemp === 'view'"
          />
        </el-form-item>
        <br />
        <el-form-item label="专辑描述: " label-width="120px">
          <el-input
            :rows="5"
            type="textarea"
            style="width: 300px"
            v-model="formCustom.description"
            :disabled="doWhatTemp === 'view'"
          />
        </el-form-item>
        <br />
      </el-form>
      <br />
      <el-button
        type="primary"
        style="margin-left: 150px"
        @click="doNextStep('formCustom')"
        >下一步</el-button
      >
    </div>
    <div class="main-box" v-if="step == 2">
      <el-form :inline="true" label-width="125px" :model="formCustom">
        <el-form-item label="专辑名称: " label-width="120px">
          <p>{{ formCustom.albumName }}</p>
        </el-form-item>
        <el-form-item label="出版社: " label-width="120px">
          <p>{{ formCustom.albumPublisher }}</p>
        </el-form-item>
        <br />
        <el-form-item label="专辑封面: " label-width="120px">
          <img :src="formCustom.img_large" width="80px" height="80px" />
        </el-form-item>
        <br />
        <el-form-item label="关联绘本: " label-width="120px">
          <el-table
            ref="multipleTable"
            :data="formCustom.res"
            stripe
            border
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column
              prop="rid"
              label="ID"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="资源名称"
              align="center"
              width="250"
            ></el-table-column>
            <el-table-column label="排序" align="center" width="250">
              <template slot-scope="scope">
                <InputNumber
                  size="small"
                  :min="1"
                  v-model="scope.row.ind"
                  :disabled="doWhatTemp === 'view'"
                  @on-change="
                    (value) =>
                      handleNumberChange(value, scope.row, scope.$index)
                  "
                ></InputNumber>
              </template>
            </el-table-column>
            <el-table-column
              prop="clevel"
              label="上下架状态"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.clevel == 0" type="danger"
                  >已下架</el-tag
                >
                <el-tag v-else-if="scope.row.clevel == 4" type="gray"
                  >审核通过</el-tag
                >
                <el-tag v-else-if="scope.row.clevel == 5" type="success"
                  >已上架</el-tag
                >
                <el-tag v-else-if="scope.row.clevel == 2" type="primary"
                  >编辑中</el-tag
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row style="margin-top: 5px">
            <el-col :span="3">
              <el-button
                type="primary"
                @click="delResItem"
                :disabled="doWhatTemp === 'view'"
                >删除资源</el-button
              >
            </el-col>
            <el-col :span="3">
              <AddPictureBook
                :doWhatTemp="doWhatTemp"
                :currCpId="currCpId"
                styleShow="btn"
                :isSystem="isSystem"
                @resourseSel="handleResAdd2Server"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <br />
      <el-button type="primary" style="margin-left: 150px" @click="doLastStep"
        >上一步</el-button
      >
      <el-button
        type="primary"
        style="margin-left: 150px"
        @click="finishEdit"
        :disabled="doWhatTemp === 'view'"
        >完成</el-button
      >
    </div>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import { checkFormat } from "./book";
import AddPictureBook from "./components/AddPictureBook";
export default {
  name: "addAlbum",
  components: { AddPictureBook },
  data() {
    return {
      formCustom: {
        albumName: "",
        albumPublisher: "",
        img_large: "",
        res: [],
        readCount: null,
        description: "",
      },
      doWhatTemp: "",
      uploadData: {
        isOnlyMP3: "false",
        pdfToPng: "true",
      },
      currCpId: null,
      currAlbumId: 0,
      step: 1,
      multipleSelection: [],
      isSystem: false,
    };
  },
  created() {
    this.currCpId = Number(this.$route.query.cpid);
    this.isSystem = Boolean(this.$route.query.isSystem);
    this.doWhatTemp = this.$route.query.do;
    if (this.doWhatTemp == "edit" || this.doWhatTemp == "view") {
      this.currAlbumId = Number(this.$route.query.albumId);
      this.fetchquery().then((res) => {
        if (res != null) {
          let params = JSON.parse(res);
          this.formCustom.albumName = params.name;
          this.formCustom.albumPublisher = params.company;
          this.formCustom.img_large = params.img_large;
          this.formCustom.readCount = params.words_count;
          this.formCustom.description = params.description;
          this.fetchAlbumRes(this.currAlbumId);
        }
      });
    }
  },
  watch: {},
  methods: {
    doNextStep() {
      if (this.doWhatTemp != "view") {
        this.saveAlbum();
      } else {
        this.step = 2;
      }
    },
    doLastStep() {
      this.step = 1;
    },
    handleResAdd(arr) {
      for (let i in arr) {
        this.formCustom.res.push(arr[i]);
      }
      this.resResort();
    },
    handleResAdd2Server(arr) {
      if (arr.length == 0) {
        alert("请选择要添加的资源");
        return;
      } else {
        let res = [];
        for (let i = 0; i < arr.length; ++i) {
          let tmp = {
            id: arr[i].id,
            dbId: arr[i].dbId,
          };
          res.push(tmp);
        }
        let params = {
          appId: this.$API.APPID,
          id: this.currAlbumId,
          resList: res,
        };
        this.$axios
          .post("/aries-api/album/saveRes", params)
          .then((response) => {
            console.log(response);
            let m = response.data;
            if (m.result == 0) {
              this.fetchAlbumRes(this.currAlbumId);
              this.$Message.success("关联成功!");
            } else {
              ApiMessage(this, m.msg, "error");
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
          });
      }
    },
    finishEdit() {
      let res = [];
      for (let i = 0; i < this.formCustom.res.length; ++i) {
        let tmp = {
          id: this.formCustom.res[i].rid,
          dbId: this.formCustom.res[i].dbId,
          sort: this.formCustom.res[i].ind,
        };
        res.push(tmp);
      }
      let params = {
        appId: this.$API.APPID,
        id: this.currAlbumId,
        resList: res,
      };
      this.$axios
        .post("/aries-api/album/saveRes", params)
        .then((response) => {
          console.log(response);
          let m = response.data;
          if (m.result == 0) {
            this.$router.push({
              name: "library",
            });
            // this.$router.push({ name: "albums" });
          } else {
            ApiMessage(this, m.msg, "error");
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    delResItem() {
      this.$Modal.confirm({
        title: "确认删除？",
        content: "<ul><li>请确认是否删除资源</li></ul>",
        onOk: () => {
          let len= this.multipleSelection.length;

          if (len == 0) {
            alert("请选择要删除的资源");
          } else {
            let resList = [];
            for (let i = 0; i < len; ++i) {
              let temp = {
                id: this.multipleSelection[i].rid,
                dbId: this.multipleSelection[i].dbId,
              };
              resList.push(temp);
            }
            let params = {
              appId: this.$API.APPID,
              id: this.currAlbumId,
              resList: resList,
            };
            this.$axios
              .post("/aries-api/album/delRes", params)
              .then((response) => {
                console.log(response);
                let m = response.data;
                if (m.result == 0) {
                  this.fetchAlbumRes(this.currAlbumId);
                  this.$Message.success("删除成功!");
                } else {
                  ApiMessage(this, m.msg, "error");
                }
              })
              .catch((error) => {
                ApiMessage(this, error.toString(), "error");
              });
          }
        },
      });
    },
    resResort() {
      if (this.formCustom.res.length > 0) {
        for (let i = 0; i < this.formCustom.res.length; ++i) {
          this.formCustom.res[i].ind = i + 1;
        }
      }
    },
    fetchquery() {
      return new Promise((resolve, reject) => {
        let params = {
          appId: this.$API.APPID,
          id: this.currAlbumId,
        };
        this.$axios
          .post("/aries-api/album/get", params)
          .then((response) => {
            console.log(response);
            var m = response.data;
            if (m.result == 0) {
              resolve(JSON.stringify(m.data));
            } else {
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
    fetchAlbumRes(id) {
      let params = {
        appId: this.$API.APPID,
        id: id,
        page: 1,
        pageSize: 500,
      };
      this.$axios
        .post("/aries-api/album/resList", params)
        .then((response) => {
          console.log(response);
          var m = response.data;
          if (m.result == 0) {
            this.formCustom.res = m.data.list;
            this.resResort();
          } else {
            alert(m.msg);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    saveAlbum() {
      let res = [];
      for (let i = 0; i < this.formCustom.res.length; ++i) {
        let idTemp = null;
        if (this.formCustom.res[i].rid != undefined) {
          idTemp = this.formCustom.res[i].rid;
        } else {
          idTemp = this.formCustom.res[i].id;
        }
        let tmp = {
          id: idTemp,
          dbId: this.formCustom.res[i].dbId,
        };
        res.push(tmp);
      }
      if (res.length == 0) {
        alert("请为专辑关联绘本");
        return;
      }
      let params = {
        appId: this.$API.APPID,
        id: this.currAlbumId,
        pid: 0,
        type: 1,
        name: this.formCustom.albumName,
        description: this.formCustom.description,
        company: this.formCustom.albumPublisher,
        words_count: this.formCustom.readCount,
        img_large: this.formCustom.img_large,
        img_small: this.formCustom.img_large,
        resList: res,
      };
      if (this.currCpId != 0) {
        params.dbId = this.currCpId;
      } else {
        params.owner = this.$API.APPID;
      }
      this.$axios
        .post("/aries-api/album/save", params)
        .then((response) => {
          console.log(response);
          if (response.data.result == "0") {
            this.fetchAlbumRes(response.data.data.id);
            this.currAlbumId = response.data.data.id;
            this.step = 2;
          } else {
            alert(
              "post failed:" + response.data.result + ". " + response.data.msg
            );
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
    },
    onBeforeUpload(file) {
      if (!checkFormat(file, "picture")) {
        return false;
      }
    },
    onSuccessUpload(response, file, fileList) {
      console.log(response);
      this.formCustom.img_large = response.data[0].url;
      this.$Message.success("上传成功!");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleNumberChange(newIndex, book, oldIndex) {
      if (newIndex != null) {
        let changeNum = 0;
        oldIndex += 1;
        if (newIndex > oldIndex) {
          this.formCustom.res.splice(newIndex, 0, book);
          this.formCustom.res.splice(oldIndex - 1, 1);
          changeNum = newIndex - oldIndex;
          this.$nextTick(() => {
            for (let i = 0; i < changeNum; ++i) {
              let temp = this.formCustom.res[i + oldIndex - 1];
              temp.ind = this.formCustom.res[i + oldIndex - 1].ind - 1;
              this.$set(this.formCustom.res, i + oldIndex - 1, temp);
            }
          });
        } else if (newIndex < oldIndex) {
          this.formCustom.res.splice(newIndex - 1, 0, book);
          this.formCustom.res.splice(oldIndex, 1);
          changeNum = oldIndex - newIndex;
          this.$nextTick(() => {
            for (let i = 0; i < changeNum; ++i) {
              let temp = this.formCustom.res[i + newIndex];
              temp.ind = this.formCustom.res[i + newIndex].ind + 1;
              this.$set(this.formCustom.res, i + newIndex, temp);
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// addAlbum.vue?52cba246